import { ReactNode } from 'react'
import CfpThreeDotsMenu from './CfpThreeDotsMenu'

interface DropItem {
  label: string
  icon?: ReactNode
  onClick: () => void
  checked?: boolean
  danger?: boolean
}

interface TaThreeDotsProps {
  droplist: DropItem[]
  item?: any
  index?: number
}

export default function TaThreeDots({ droplist }: TaThreeDotsProps) {
  return <CfpThreeDotsMenu items={droplist} />
}
